import { Button } from "@/components/ui/button";
import { SignInButton } from "@clerk/clerk-react";

export const LoginPage = () => {
  return (
    <div className="bg-white w-full h-screen flex flex-col items-center justify-center gap-8 p-4">
      <section className="flex flex-col w-full max-w-md p-10 bg-slate-50 rounded-xl gap-5">
        <img src="/black-transparent.svg" alt="logo" className="w-10 h-10" />
        <div className="flex flex-col gap-2">
          <h1 className="text-2xl font-light tracking-wider">
            Welcome to Uavity
          </h1>
          <p className="text-md text-gray-500">
            The easiest way to monitor your Airspace.
          </p>
        </div>

        <SignInButton>
          <Button className="w-full">
            Get Started
          </Button>
        </SignInButton>

        <p className="text-center text-sm text-gray-500">
          <a
            href="/legal/privacy-policy"
            className="text-blue-500 hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          {' • '}
          <a
            href="/legal/terms-of-use"
            className="text-blue-500 hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Use
          </a>
        </p>
      </section>
    </div>
  );
};
